var map = {
	"./noble01/游戏畅玩@2x.png": "764b",
	"./noble02/游戏畅玩@2x.png": "a1a9",
	"./noble03/游戏畅玩@2x.png": "0e4e",
	"./noble04/游戏畅玩@2x.png": "5b4f",
	"./noble05/游戏畅玩@2x.png": "5eff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "899c";